import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export async function getCombinations(clientID, productID) {
    let combinations = [];
    await axios.get(`${apiUrl}/getCombinations`, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            if (response.data.combinations)
                combinations = response.data.combinations;
        }).catch(console.error);
    return combinations;
}

export async function addCombination(clientID, productID, newCombination) {
    let result = {error: true, message: "Unable to add the combination"};
    await axios.post(`${apiUrl}/addCombination`, {combination: newCombination}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function updateCombination(clientID, productID, newCombination, oldSku) {
    let result = {error: true, message: "Unable to update the combination"};
    await axios.put(`${apiUrl}/updateCombination`, {combination: newCombination, old_sku: oldSku}, {params: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function removeCombination(clientID, productID, combination) {
    let result = {error: true, message: "Unable to remove the combination"};
    await axios.delete(`${apiUrl}/removeCombination`, {data: {client_id: clientID, product_id: productID, combination: combination}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function removeAllCombinations(clientID, productID) {
    let result = {error: true, message: "Unable to remove the combinations"};
    await axios.delete(`${apiUrl}/removeAllCombinations`, {data: {client_id: clientID, product_id: productID}})
        .then(response => {
            result.error = (response.data.status === "error");
            result.message = response.data.message;
        }).catch(console.error);
    return result;
}

export async function searchLinkedProductsFromSku(clientID, productSku) {
    let products = [];
    await axios.post(`${apiUrl}/searchLinkedProductsFromSku`, {sku: productSku.toString()}, {params: {client_id: clientID}})
        .then(response => {
            if (response.data.products)
                products = response.data.products;
        }).catch(console.error);
    return products;
}